import jsPDF from 'jspdf'
import { addSwimLanes } from '@/helpers/svgConvert'

export function cloneAndPrepareSvg (svgElement, workflowData) {
  const clonedSvg = svgElement.cloneNode(true)

  resolveThemeColors(clonedSvg, svgElement)
  updateTextElements(clonedSvg)
  updateConnectionLabels(clonedSvg)

  updateSequenceArrows(clonedSvg)

  addSwimLanes(clonedSvg, workflowData.svgLanesData, workflowData.roleDefinition.color.rgb, workflowData.hasGroups)

  removeUnwantedElements(clonedSvg)

  addWhiteBackground(clonedSvg)

  addCustomFont(clonedSvg)

  return clonedSvg
}

function resolveThemeColors (clonedSvg, sourceSvg) {
  const clonedEls = clonedSvg.querySelectorAll('[class*="theme-fill-"]')
  for (const clonedEl of clonedEls) {
    if (!clonedEl.id) continue
    const liveEl = sourceSvg.getElementById(clonedEl.id)
    if (!liveEl) continue
    const style = window.getComputedStyle(liveEl)
    clonedEl.style.fill = style.fill
    clonedEl.style.stroke = style.stroke
    clonedEl.style.fillOpacity = style.fillOpacity
  }

  const styledEls = clonedSvg.querySelectorAll('[style]')
  for (const el of styledEls) {
    if (el.style.fill === 'var(--diagram-stroke)') {
      el.style.fill = '#1F2833'
    }
    if (el.style.stroke === 'var(--diagram-stroke)') {
      el.style.stroke = '#1F2833'
    }
    if (el.style.fill === 'var(--diagram-lane-divider)') {
      el.style.fill = '#d7dbe0'
    }
    if (el.style.stroke === 'var(--diagram-lane-divider)') {
      el.style.stroke = '#d7dbe0'
    }
    if (el.style.fill === 'var(--diagram-border)') {
      el.style.fill = '#A3ADB9'
    }
    if (el.style.stroke === 'var(--diagram-border)') {
      el.style.stroke = '#A3ADB9'
    }
  }
}

function updateTextElements (svgElement) {
  const textElements = [...svgElement.querySelectorAll('.gateway-name'), ...svgElement.querySelectorAll('.event-name')]
  textElements.forEach((textElement) => {
    const foreignObject = textElement.classList.contains('gateway-name')
      ? textElement.parentNode.parentNode
      : textElement.parentNode

    const textContent = textElement.textContent || ''
    const fontSize = textElement.style.fontSize

    const div = document.createElement('div')
    div.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml')
    div.style.cssText = `
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      font-size: ${fontSize};
      text-align: center;
      font-weight: 500;
      line-height: 12px;
    `
    div.textContent = textContent

    foreignObject.parentNode.replaceChild(div, foreignObject)
  })
}

function updateConnectionLabels (svgElement) {
  const labelElements = svgElement.querySelectorAll('.label-name')
  labelElements.forEach((labelElement) => {
    const text = (labelElement.textContent || '').trim()
    if (!text || labelElement.classList.contains('label-empty')) {
      return
    }

    const wrapper = labelElement.parentNode
    const foreignObject = wrapper?.parentNode
    if (!foreignObject || foreignObject.tagName.toLowerCase() !== 'foreignobject') {
      return
    }

    const onLine = !!labelElement.closest('.label-on-line')
    const fontSize = labelElement.style.fontSize || '12px'

    const container = document.createElement('div')
    container.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml')
    container.style.cssText = `
      display: flex;
      align-items: ${onLine ? 'center' : 'flex-start'};
      justify-content: ${onLine ? 'center' : 'flex-start'};
      height: 100%;
      width: 100%;
    `

    const box = document.createElement('div')
    box.style.cssText = `
      box-sizing: border-box;
      max-width: 100%;
      min-width: 0;
      padding: 4px;
      border-radius: 4px;
      background: #FCFCFC;
      color: #1F2833;
      font-size: ${fontSize};
      font-weight: 500;
      line-height: 12px;
      text-align: center;
      word-break: break-word;
      ${onLine ? 'border: 1px solid #1F2833;' : ''}
    `
    box.textContent = text

    container.appendChild(box)
    foreignObject.replaceChild(container, wrapper)
  })
}

function updateSequenceArrows (svgElement) {
  const sequenceArrows = svgElement.querySelectorAll('.sequence-arrow')
  sequenceArrows.forEach((element) => {
    element.setAttribute('fill', 'none')
    element.setAttribute('stroke', '#1F2833')
    element.setAttribute('stroke-linejoin', 'round')
    element.setAttribute('stroke-linecap', 'round')
    element.setAttribute('marker-end', 'url(\'#sequenceflow-end-white-black-1r79xjtcycpwpzz6dais2xasb\')')
  })
}

function removeUnwantedElements (svgElement) {
  const elementsToRemove = [
    ...svgElement.querySelectorAll('.add-event-button'),
    ...svgElement.querySelectorAll('[width="104"][height="16"]'),
    ...svgElement.querySelectorAll('.delete-group-btn'),
    ...svgElement.querySelectorAll('.lane-rect'),
    ...svgElement.querySelectorAll('.lane-cell-menu-container')
  ]
  elementsToRemove.forEach((element) => {
    element.parentNode.removeChild(element)
  })
}

function addCustomFont (svgElement) {
  const defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs')
  const style = document.createElementNS('http://www.w3.org/2000/svg', 'style')
  style.textContent = `
    @font-face {
      font-family: 'Inter';
      src: url('https://rsms.me/inter/font-files/Inter-Regular.woff2') format('woff2');
    }
    * {
      font-family: 'Inter', sans-serif;
    }
    svg {
      fill: #ffffff;
    }
    #flowchart path {
      stroke: #1F2833;
      stroke-width: 1px;
      fill-opacity: 1;
    }
    .sequence-arrow {
      fill: none;
      stroke: #1F2833;
      stroke-linejoin: round;
      stroke-linecap: round;
    }
    .swim-lane {
      stroke: black;
      stroke-width: 2px;
      fill-opacity: 0;
    }
    .lane-cell {
      fill: transparent;
      stroke: #d7dbe0;
      stroke-width: 1px;
    }
    .group {
      background: #CFD3D9;
      height: 24px;
      padding: 4px 8px 3px 8px;
      text-align: center;
    }
  `
  defs.appendChild(style)
  svgElement.prepend(defs)
}

function addWhiteBackground (svgElement) {
  const width = svgElement.getAttribute('width') || svgElement.width?.baseVal?.value
  const height = svgElement.getAttribute('height') || svgElement.height?.baseVal?.value
  const bg = document.createElementNS('http://www.w3.org/2000/svg', 'rect')
  bg.setAttribute('x', '0')
  bg.setAttribute('y', '0')
  bg.setAttribute('width', width)
  bg.setAttribute('height', height)
  bg.setAttribute('fill', '#ffffff')
  svgElement.prepend(bg)
}

function encodeSvg (svgStr) {
  return btoa(new TextEncoder().encode(svgStr).reduce((data, byte) => data + String.fromCharCode(byte), ''))
}

export function exportDiagramAsPdf (svgElement, workflowName) {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  const interFont = new FontFace('Inter', 'url(https://rsms.me/inter/font-files/Inter-Regular.woff2)')

  return interFont.load().then((loadedFont) => new Promise((resolve, reject) => {
    document.fonts.add(loadedFont)

    const svgData = new XMLSerializer().serializeToString(svgElement)
    const img = new Image()

    const width = svgElement.width.baseVal.value
    const height = svgElement.height.baseVal.value

    img.onload = function () {
      try {
        canvas.width = img.width
        canvas.height = img.height

        ctx.font = 'Inter'
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(img, 0, 0)

        // eslint-disable-next-line
        const pdf = new jsPDF(width > height ? 'l' : 'p', 'pt', [width, height])
        pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, width, height)
        pdf.save(`${workflowName}.pdf`)
        resolve(true)
      } catch (err) {
        reject(err)
      }
    }

    img.onerror = () => reject(new Error('Failed to render the diagram image'))
    img.src = 'data:image/svg+xml;base64,' + encodeSvg(svgData)
  })).catch((err) => {
    console.error('Failed to export PDF:', err)

    return false
  })
}
